import { EventEmitter, OnInit } from "@angular/core";
var TalentPoolCandidateCard = /** @class */ (function () {
    function TalentPoolCandidateCard() {
        this.openDetail = new EventEmitter();
    }
    TalentPoolCandidateCard.prototype.ngOnInit = function () { };
    TalentPoolCandidateCard.prototype.emitOpenDetail = function () {
        this.openDetail.emit(this.candidate);
    };
    Object.defineProperty(TalentPoolCandidateCard.prototype, "numberOfApplications", {
        get: function () {
            return this.candidate.other_applications.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TalentPoolCandidateCard.prototype, "numberOfCv", {
        get: function () {
            var uniqueCvIds = new Set(this.candidate.other_applications
                .filter(function (cv) { return cv.curriculumId !== null; })
                .map(function (cv) { return cv.curriculumId; }));
            return uniqueCvIds.size;
        },
        enumerable: true,
        configurable: true
    });
    return TalentPoolCandidateCard;
}());
export { TalentPoolCandidateCard };
